import React, { useState } from 'react';
import cn from 'classnames';

import styles from './SelectImageButtons.module.css';

const SelectButtons = (props) => {
  const {
    buttonsData,
    onChange,
    defaultValue = null,
  } = props;

  const [selectedValue, setSelectedValue] = useState(defaultValue);

  const onChangeHandler = (value) => {
    onChange(value);
    setSelectedValue(value);
  };

  return (
    <div className={styles.wrapper}>
      {buttonsData.map((buttonData) => (
        <div
          key={buttonData.value}
          className={cn(styles.button, { [styles.active]: buttonData.value === selectedValue })}
          onClick={() => onChangeHandler(buttonData.value)}
        >
          <img src={buttonData.image} />
          {buttonData.label}
        </div>
      ))}
    </div>
  );
};

export default SelectButtons;
